export const alpha = (value) => {
    return /^[a-zA-Z]+$/.test(value);
};
